import { render, staticRenderFns } from "./SubmitSubmissionSectorAssociationRepresentative.vue?vue&type=template&id=05c87623&"
import script from "./SubmitSubmissionSectorAssociationRepresentative.vue?vue&type=script&lang=js&"
export * from "./SubmitSubmissionSectorAssociationRepresentative.vue?vue&type=script&lang=js&"
import style0 from "./SubmitSubmissionSectorAssociationRepresentative.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports